export const STATUS_FAILURE_OFFICE_NOTEXISTS = 0x00000301; // 769
export const STATUS_FAILURE_OFFICE_EXISTS = 0x00000302; // 770
export const STATUS_FAILURE_OFFICE_KEY = 0x00000303; // 771
export const STATUS_FAILURE_STAFF_NOTEXISTS = 0x00000311; // 785
export const STATUS_FAILURE_STAFF_EXISTS = 0x00000312; // 786
export const STATUS_FAILURE_STAFF_PASS = 0x00000313; // 787
export const STATUS_FAILURE_SHOP_NOTEXISTS = 0x00000321; // 801
export const STATUS_FAILURE_SHOP_EXISTS = 0x00000322; // 802
export const STATUS_FAILURE_NG_DUPLICATE = 0x00000331; // 817
export const STATUS_FAILURE_NG_PHONE_NOTMOBILE = 0x00000332; // 818
export const STATUS_FAILURE_NG_AUTH_STFF = 0x00000333; // 819
export const STATUS_FAILURE_NG_AUTH_TIME = 0x00000334; // 820